import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaRegUser } from "react-icons/fa";
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})



export default function CourseTestimonial({TestiData,SectionRef,title}) {

    

const settings = {
  dots: true,
  speed: 500,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 1,
  arrows:false,
  customPaging: (i) => (
    <div className="slick-dot" key={i}>
      <style jsx>
        {`

          .slick-dot {
               width: 19px;
            height: 10px;
            background-color: #FFEDD1;
            border-radius: 10px;
            margin: 1px 5px;
            cursor: pointer;
            display: inline-block;
            margin-bottom:-3px;
          }
      
 .slick-dots li {
          background-color: black !important;
        }

          @media only screen and (max-width: 1023px){
            .slick-dot {
              width: 19px;
              height: 10px;
              background-color: #FFEDD1; /* Default color */
              border-radius: 10px;
              margin: 1px 5px;
              cursor: pointer;
              display: inline-block;
              margin-bottom:30px;
            }
          }
        `}
      </style>
    </div>
  ), 
   
  responsive: [
    {
      breakpoint: 1223,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      }
    },
    
  ]
}; 


  return (
    <>
<section className='testi-bg' ref={SectionRef}> 
<div className='container '>
<h3 className={`fs-30 tfs-28 mfs-21 fwb600  tac  ${popins.className}`}> Student Reviews of  <span className={`ylw-clr ${popins.className}`}>   {title} Training </span> </h3>
<p className={`fs-16 mfs-15 fwb500 mt28 tmt24 mmt20 m0a para-cnt tac ${quickSand.className}`}>Explore honest reviews, ratings, and student feedback to make informed decisions and find the perfect course for your learning goals</p>
{/* Box */}
<Slider {...settings}>


 {TestiData.map((items,index)=>{
        return(
          <div className='col mt32 mmt28' key={index}>
          <div className='df fjse'>
        <div className='testi-box ' >
 <div className='df fjsb'>         
<div className='df fac gap28'>
<div className='img'>
<FaRegUser className='pd8 ylw-clr tac' size={26}/>
</div>
<div className=''>
  <p className={`fs-16 mfs-15 mfs-12 cw fwb500 ${popins.className}`}>{items.username}</p>
  <p className={`fs-12 fwb500 mt10 cw ${popins.className}`}>{items.course}</p>
</div>

</div>
<div className=''>
<Image src={"/new-course-details/testimonial/quotes.png"} alt={`Quote from ${items.username} about ${items.course} course`} width={"50"} height={"34"} quality={100}/>
</div>

</div>
<div className='df fjc pdt6 fdc'>
<p className={`fs-14 mt16 fwb500 review cw  ${quickSand.className}`}>{items.review}</p>
    <Image className='mt24 mmt16' src={"/new-course-details/testimonial/star.png"} alt='Rating' width={"75"} height={"16"} quality={100}/>


</div>

</div>


</div></div> )
      })}</Slider></div> 
</section>
<style jsx>
{`
.para-cnt{
     width: 75%;
    }
.review{
height: 100px;
}
.title-box{
background: #FDCF7466;
width: 285px;
border-radius: 10px;

}

    .col {
      width: 100%; // Set the width to 100% for smaller screens
      margin-bottom: 52px;
      margin-left: auto;
      margin-right: auto; // Center the slider on the screen
    }

.testi-bg{
  padding: 70px 0px;
width: 100%;
overflow: hidden;

}
.img{
background: #fff;
border-radius: 50px;
}
.testi-box{
    width: 100%;
    height: 230px;
    border-radius: 16px;
  background: #FFA900;
    cursor: pointer;
    margin:0px 15px;
    padding:10px;
}

@media only screen and (min-width: 768px) and (max-width:1023px) {
   .testi-box{
            width: 350px !important;
            height: 230px !important;
            border-radius: 12.2px;
            background: #FFA900;
        }
.review{
height: auto;
}
.testi-bg{
  padding: 40px 0px;
width: 100%;
overflow: hidden;

}
}
@media only screen and (max-width: 768px){
   .testi-box{
            width: 100% !important;
            height: auto !important;
            border-radius: 12.2px;
            background: #FFA900;
        }
      .para-cnt{
              width: 85%;
      }
.review{
height: auto;
}
.testi-bg{
  padding: 30px 0px;
width: 100%;
overflow: hidden;

}
}

@media only screen and (max-width: 1023px){
    .testi-bg{
        width: 100%;     
        }
        .testi-box{
            width: 280px;
            height: 190.62px;
            border-radius: 12.2px;
            background: #FFA900;
        }
}
`}

</style>

</>
  )
}
